import withStyles from '@material-ui/core/styles/withStyles';
import CardContent from '@material-ui/core/CardContent';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(1, 0, 0),
  },
});

export default withStyles(styles)(CardContent);
